<template>
  <div class="pageview">
    <el-form
      :model="queryParams"
      ref="queryForm"
      size="small"
      :inline="true"
      v-show="showSearch"
      label-width="120px"
    >
   <el-form-item label="内容" prop="content">
        <el-input v-model="queryParams.content" placeholder="请输入内容" learable @keyup.enter.native="handleQuery" />
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-search"
          size="mini"
          @click="handleQuery"
          >搜索</el-button
        >
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery"
          >重置</el-button
        >
        <el-button
          type="primary"
          plain
          icon="el-icon-plus"
          size="mini"
          @click="$refs.addVoice.addCreateForm(userId, userName, platForm)"
          >新增</el-button
        >
      </el-form-item>
    </el-form>
    <el-table v-loading="loading" :data="dataList">
      <el-table-column label="用户名" align="center" prop="userName" />
      <el-table-column
        label="内容"
        align="center"
        prop="content"
        show-overflow-tooltip
      />
      <el-table-column
        label="语音文件"
        align="center"
        prop="voiceLink"
        width="180"
      >
      <template slot-scope="scope">
       <!-- <el-button
              type="primary"
              icon="el-icon-video-play"
              circle
              @click="downloadFileWithAuth"
            ></el-button> -->
              <audio controls class="addAudio_right_box_bottom_audio" :src="scope.row.voiceLink">
              <!-- <source :src="voiceLink" type="audio/mpeg" /> -->
            </audio>
            </template>
        <!-- <template slot-scope="scope">
          <span>{{ parseTime(scope.row.appointmentTime, '{y}-{m}-{d} ') }} 播放，下载</span>
        </template> -->
      </el-table-column>
      <el-table-column label="创建时间" align="center" prop="createTime" />
      <el-table-column
        label="操作"
        align="center"
        class-name="small-padding fixed-width"
        width="450"
      >
  <template slot-scope="scope">
    <el-button
              type="primary"
              icon="el-icon-download"
              circle
              @click="downloadFileWithAuth(scope.row.voiceLink)"
            ></el-button>
          <el-button size="mini" type="text" icon="el-icon-delete" @click="handleDelete(scope.row)">删除</el-button>
        </template> 
      </el-table-column>
    </el-table>

    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    />
<addVoice ref="addVoice" @ok="getList"/>
  </div>
</template>

<script>
import {getvoiceList, delVoiceSynthesis,stream} from "@/api/index";
import axios from "axios";
import addVoice from "@/views/system/VoiceRecognition/addVoice";
export default {
  components: {
    addVoice
  },
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        platForm: "",
       userId: "",
       content:'',
       type:2
      },
      loading: false,
      total: 0,
      dataList: [],
      showSearch: true,
       userId: "",
        userName: "",
        platForm: "",
        oriApi: "",
    };
  },
  created() {},
  mounted() {
 this.userId = this.$route.query.userId
    this.userName = this.$route.query.userName
    this.platForm = this.$route.query.platForm
    this.oriApi = this.$route.query.oriApi
    this.queryParams.userId = this.userId
    this.queryParams.platForm = this.platForm
    this.getList()
  },
  methods: {
    getList() {
      getvoiceList(this.queryParams).then((response) => {
        const result = response.data.data;
        console.log(result);
        this.dataList = result.list;
        this.total = result.total;
      });
    },
    handleDelete(row) {
       const ids = row.id
      this.$modal.confirm('是否确认删除编号为"' + ids + '"的数据项？').then(function () {
        return delVoiceSynthesis({
          id:ids
        })
      }).then(() => {
         this.getList()
        this.$modal.msgSuccess("删除成功")
      }).catch(() => { })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParams= {
        pageNum: 1,
        pageSize: 10,
         platForm: this.platForm,
       userId: this.userId,
       content:'',
       type:2
      }
      // this.resetForm("queryForm");
      this.handleQuery();
    },
       async downloadFileWithAuth(voiceLink) {
      const fileUrl = voiceLink; // 需要认证的 URL
      const fileName = "audio.mp3"; // 你期望的文件名

      try {
        // 使用 axios 请求文件，responseType 设置为 'blob'
        const response = await axios.get(fileUrl, {
          responseType: "blob", // 关键：告诉 axios 将响应作为二进制大对象处理
          headers: {
            // 如果需要认证，添加请求头
            // 'Authorization': 'Bearer your-jwt-token-here'
            // 其他可能的头...
          },
        });
        console.log(response);
        // 检查响应状态
        if (response.status === 200) {
          // 创建一个 Blob URL
          const blob = new Blob([response.data], { type: response.data.type });
          console.log(blob);
          const url = window.URL.createObjectURL(blob);
          console.log(url);
          // 创建一个临时的 <a> 标签来触发下载
          const link = document.createElement("a");
          link.href = url;
          link.download = fileName; // 设置下载的文件名
          document.body.appendChild(link);
          link.click();

          // 清理：移除元素并释放 Blob URL
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);

          this.$modal.msgSuccess("下载成功");
        } else {
          console.error("下载失败:", response.statusText);
        }
      } catch (error) {
        console.error("下载过程中出错:", error);
        // 处理错误，例如显示错误消息
      }
    },
  },
};
</script>
<style scoped>
.addAudio{
display: flex;
justify-content: space-between;
/* align-items: center; */
}
.addAudio_left{
width: 40%;
}
.addAudio_left_title{
font-size: 24px;
margin-bottom: 20px;
display: block;
width: 100%;
text-align: center;

}
.addAudio_midden{
    width: 10%;
    display: flex;
    justify-content: center;
    align-items: center;

}
.addAudio_right{
width: 40%;
}
.addAudio_right_box{
display: flex;
flex-direction: column;
}
.addAudio_right_box_bottom{

}
.addAudio_right_box_bottom_audio{
  width: 100%;
  margin-top: 20px;
}
</style>

